var $openModal,
    $modalContentSource,
    $modalContent,
    $modal,
    $body,
    $closeModal;


$(document).ready(function ($) {
    $openModal = $('.js-open-modal');
    $modalContent = $('.js-modal-content');
    $closeModal = $('.js-close-modal');
    $modal = $('.js-modal');
    $body =  $('body');

    $openModal.on('click', function (e) {
        e.preventDefault();

        let target = $(this).attr('data-target');
        if (typeof(target) === "undefined" ) {
            $modalContentSource = $(this).next('.js-modal-content-source').clone();
        } else {
            $modalContentSource = $('#' + target).clone();
        }
        $modalContent.html($modalContentSource);
        $modalContent.find('.js-modal-content-source').removeClass('d-none');
        $modal.removeClass('is-closed');
        $body.addClass('modal-is-open');
    });

    $closeModal.on('click', function () {
        var promo = $modalContent.find('.js-promo-modal');
        if(promo) {
            var destination = promo.data('destination');
            var text = promo.text();
            var bracket = $('.js-staffel-bracket.is-current[data-destination=' + destination + ']').text();
            var regex = new RegExp(bracket, "gi");
            var updatedText = text.replace(regex, "[bracket]");
            $(".js-promo-modal").text(updatedText);
        }
        $modal.addClass('is-closed');
        $body.removeClass('modal-is-open');
    });
});
